import { defineMessages } from "react-intl"

export const bankDetailDropdownMessages = defineMessages({
  accountType_Checking: { defaultMessage: "Checking" },
  accountType_Savings: { defaultMessage: "Savings" }
})
